import React from "react"


class Payments extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
           <section>

            </section>
        )
    }

}

export default Payments


// WEBPACK FOOTER //
// ./src/Setup/modules/account/views/Payments.js